import React from 'react';
import { useParams } from 'react-router-dom';
import WorkPageTemplate from '../../components/work/WorkPageTemplate';
import { loadCaseStudyData, getCaseStudiesNavigation } from '../../utils/workUtils';

const CaseStudyPage = () => {
  const { id } = useParams();
  return (
    <WorkPageTemplate id={id} loadDataFn={loadCaseStudyData} getNavigationFn={getCaseStudiesNavigation} />
  );
};

export default CaseStudyPage;

